import { Box, styled } from "@mui/material";
import pxToRem from "theme/base/pxToRem";

export const TableContainer = styled(Box)(({ theme }) => ({
  tr: {
    minHeight: pxToRem(40),
  },
  table: {
    height: "-webkit-fill-available !important",
  },
  thead: {
    tr: {
      backgroundColor: `${theme.palette.stroke.strokeDefault} !important`,
      th: {
        div: {
          fontWeight: theme.typography.fw_regular_400,
        },
      },
    },
  },
  tbody: {
    tr: {
      borderBottom: `1px solid ${theme.palette.stroke.strokeDefault}`,
      height: "auto",
      minHeight: pxToRem(40),
      "& :odd": {
        backgroundColor: "red",
      },
    },
    "tr:nth-child(even)": {
      backgroundColor: theme.palette.background.bgTable,
    },
  },
}));
